import React from "react";
import './tutorExpertise.scss';
import {Collapse, Divider, Table} from "antd";
import { CaretRightOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const TutorExpertise = () => {

    const dataSource = [
        {
            key: '1',
            exam: '',
            board: 'CBSE',
            standard: '8',
            subject:'Mathematics',
            chapters:'Trigonometry and Functions'
        },
        {
            key: '2',
            exam: '',
            board: 'CBSE',
            standard: '8',
            subject:'Mathematics',
            chapters:'Trigonometry and Functions'
        },
        {
            key: '3',
            exam: 'JEE Main',
            board: '',
            standard: '',
            subject:'Mathematics',
            chapters:'Trigonometry and Functions'
        },
    ];

    const tagColumns = [
        {
            title: 'Exam',
            dataIndex: 'exam',
            key: 'exam',
            render: (exam:string) => exam || '-'
        },
        {
            title: 'Board',
            dataIndex: 'board',
            key: 'board',
            render: (board:string) => board || '-'
        },
        {
            title: 'Class',
            dataIndex: 'standard',
            key: 'standard',
            render: (standard:string) => standard || '-'
        },
        {
            title: 'Subject',
            dataIndex: 'subject',
            key: 'subject',
        },
        {
            title: 'Chapters',
            dataIndex: 'chapters',
            key: 'chapters',
        },
    ];

    return(
        <div className='tutor-expertise'>
            <div className='tutor-expertise__collapse-section'>
                <Collapse
                    bordered={false}
                    expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                    className="site-collapse-custom-collapse"
                    ghost
                >
                    <Panel header="Expertise" key="expertise" className="site-collapse-custom-panel">
                        <Table columns={tagColumns}
                               dataSource={dataSource}
                               pagination={false}
                               className='expertise-table'
                        />
                    </Panel>
                </Collapse>
            </div>
            <Divider/>
        </div>
    )
}

export default TutorExpertise;
